export default "__VITE_ASSET__BTCBWTTV__"